const VAR_MAP: Record<string, string> = {
  VESSEL_NAME: "vesselName",
  PASSENGER: "passenger",
  GENDER: "gender",
  DOB: "dob",
  TWIC_NUM: "twicTsaNum",
  FROM: "from",
  TO: "to",
  TRAVEL_DATE: "date",
  TIME: "time",
  HOTEL_OR_RENTAL: "hotelOrRental",
  PICKUP_DATE: "pickUpDate",
  DROPOFF_DATE: "dropOffDate",
  PHONE: "phone",
  MARINER_NAME: "marinerName",
  RATING: "rating",
  EVAL_LINK: "evalLink",
};

function applyDataToHtml(html: string, data: Record<string, string>): string {
  let result = html;
  for (const [templateVar, dataKey] of Object.entries(VAR_MAP)) {
    result = result.replaceAll(`{{${templateVar}}}`, data[dataKey] ?? "");
  }
  return result;
}

/**
 * Substitutes {{VAR_NAME}} placeholders in an email template HTML string.
 *
 * @param html - The template HTML (e.g. TRAVEL_AGENT_MULTI body with {{PASSENGER_ROWS}})
 * @param emailData - Single-row substitution data (used for TRAVEL_AGENT, EVALUATION_REMINDER)
 * @param emailDataList - Multi-row data (used for TRAVEL_AGENT_MULTI passenger rows)
 * @param rowTemplateHtml - HTML for a single passenger row; when provided with emailDataList,
 *   each passenger is rendered into this template and the results replace {{PASSENGER_ROWS}}.
 *   When omitted with emailDataList, rows must already be pre-rendered.
 */
export function substituteVars(
  html: string,
  emailData?: Record<string, string>,
  emailDataList?: Record<string, string>[],
  rowTemplateHtml?: string
): string {
  let result = html;

  if (emailData) {
    result = applyDataToHtml(result, emailData);
    result = result.replaceAll(
      "{{REJECTION_NOTE_SECTION}}",
      emailData.rejectionNote ? `<p>Rejection Note: ${emailData.rejectionNote}</p>` : ""
    );
  }

  if (emailDataList && emailDataList.length > 0 && rowTemplateHtml) {
    const rowsHtml = emailDataList
      .map((data) => applyDataToHtml(rowTemplateHtml, data))
      .join("");
    result = result.replaceAll("{{PASSENGER_ROWS}}", rowsHtml);
  }

  return result;
}
